export default [
  {
    path: '/cities',
    name: 'cities',
    component: () => import('@/views/Defines/Cities/Index.vue'),
    meta: {
      pageTitle: 'Şehir',
      breadcrumb: [
        {
          text: 'Şehir',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/cities/add',
    name: 'CitiesAdd',
    component: () => import('@/views/Defines/Cities/Add.vue'),
    meta: {
      pageTitle: 'Şehir',
      breadcrumb: [
        {
          text: 'Şehir',
          to: '/cities',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/cities/edit/:id',
    name: 'CitiesEdit',
    component: () => import('@/views/Defines/Cities/Edit.vue'),
    meta: {
      pageTitle: 'Şehir',
      breadcrumb: [
        {
          text: 'Şehir',
          to: '/cities',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/districts',
    name: 'districts',
    component: () => import('@/views/Defines/Districts/Index.vue'),
    meta: {
      pageTitle: 'İlçe',
      breadcrumb: [
        {
          text: 'İlçe',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/districts/add',
    name: 'DistrictsAdd',
    component: () => import('@/views/Defines/Districts/Add.vue'),
    meta: {
      pageTitle: 'İlçe',
      breadcrumb: [
        {
          text: 'İlçe',
          to: '/districts',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/districts/edit/:id',
    name: 'DistrictsEdit',
    component: () => import('@/views/Defines/Districts/Edit.vue'),
    meta: {
      pageTitle: 'İlçe',
      breadcrumb: [
        {
          text: 'İlçe',
          to: '/districts',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/brands',
    name: 'brands',
    component: () => import('@/views/Defines/Brands/Index.vue'),
    meta: {
      pageTitle: 'Markalar',
      breadcrumb: [
        {
          text: 'Markalar',
          active: true,
        },
      ],
      resource: 'APP_PRODUCT_BRANDS',
      action: 'read',
    },
  },
  {
    path: '/brands/add',
    name: 'BrandsAdd',
    component: () => import('@/views/Defines/Brands/Add.vue'),
    meta: {
      pageTitle: 'Markalar',
      breadcrumb: [
        {
          text: 'Markalar',
          to: '/brands',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_PRODUCT_BRANDS',
      action: 'read',
    },
  },
  {
    path: '/brands/edit/:id',
    name: 'BrandsEdit',
    component: () => import('@/views/Defines/Brands/Edit.vue'),
    meta: {
      pageTitle: 'Markalar',
      breadcrumb: [
        {
          text: 'Markalar',
          to: '/brands',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_PRODUCT_BRANDS',
      action: 'read',
    },
  },
  {
    path: '/meets',
    name: 'meets',
    component: () => import('@/views/Defines/Meets/Index.vue'),
    meta: {
      pageTitle: 'Temas Tipleri',
      breadcrumb: [
        {
          text: 'Temas Tipleri',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/meets/add',
    name: 'MeetsAdd',
    component: () => import('@/views/Defines/Meets/Add.vue'),
    meta: {
      pageTitle: 'Temas Tipleri',
      breadcrumb: [
        {
          text: 'Temas Tipleri',
          to: '/meets',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/meets/edit/:id',
    name: 'MeetsEdit',
    component: () => import('@/views/Defines/Meets/Edit.vue'),
    meta: {
      pageTitle: 'Temas Tipleri',
      breadcrumb: [
        {
          text: 'Temas Tipleri',
          to: '/meets',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/sectors',
    name: 'sectors',
    component: () => import('@/views/Defines/Sectors/Index.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Sektörler',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/sectors/add',
    name: 'SectorsAdd',
    component: () => import('@/views/Defines/Sectors/Add.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Sektörler',
          to: '/sectors',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/sectors/edit/:id',
    name: 'SectorsEdit',
    component: () => import('@/views/Defines/Sectors/Edit.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Sektörler',
          to: '/sectors',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/departments',
    name: 'departments',
    component: () => import('@/views/Defines/Departments/Index.vue'),
    meta: {
      pageTitle: 'Departmanlar',
      breadcrumb: [
        {
          text: 'Departmanlar',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/departments/add',
    name: 'DepartmentsAdd',
    component: () => import('@/views/Defines/Departments/Add.vue'),
    meta: {
      pageTitle: 'Departmanlar',
      breadcrumb: [
        {
          text: 'Departmanlar',
          to: '/departments',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/departments/edit/:id',
    name: 'DepartmentsEdit',
    component: () => import('@/views/Defines/Departments/Edit.vue'),
    meta: {
      pageTitle: 'Departmanlar',
      breadcrumb: [
        {
          text: 'Departmanlar',
          to: '/departments',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/currencies',
    name: 'currencies',
    component: () => import('@/views/Defines/Currencies/Index.vue'),
    meta: {
      pageTitle: 'Para Birimleri',
      breadcrumb: [
        {
          text: 'Para Birimleri',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/currencies/add',
    name: 'CurrenciesAdd',
    component: () => import('@/views/Defines/Currencies/Add.vue'),
    meta: {
      pageTitle: 'Para Birimleri',
      breadcrumb: [
        {
          text: 'Para Birimleri',
          to: '/currencies',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/currencies/edit/:id',
    name: 'CurrenciesEdit',
    component: () => import('@/views/Defines/Currencies/Edit.vue'),
    meta: {
      pageTitle: 'Para Birimleri',
      breadcrumb: [
        {
          text: 'Para Birimleri',
          to: '/currencies',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/units',
    name: 'units',
    component: () => import('@/views/Defines/Units/Index.vue'),
    meta: {
      pageTitle: 'Birim Tipleri',
      breadcrumb: [
        {
          text: 'Birim Tipleri',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/units/add',
    name: 'UnitsAdd',
    component: () => import('@/views/Defines/Units/Add.vue'),
    meta: {
      pageTitle: 'Birim Tipleri',
      breadcrumb: [
        {
          text: 'Birim Tipleri',
          to: '/units',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/units/edit/:id',
    name: 'UnitsEdit',
    component: () => import('@/views/Defines/Units/Edit.vue'),
    meta: {
      pageTitle: 'Birim Tipleri',
      breadcrumb: [
        {
          text: 'Birim Tipleri',
          to: '/units',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/product_types',
    name: 'product_types',
    component: () => import('@/views/Defines/Product_types/Index.vue'),
    meta: {
      pageTitle: 'Ürün Grupları',
      breadcrumb: [
        {
          text: 'Ürün Grupları',
          active: true,
        },
      ],
      resource: 'APP_PRODUCT_TYPES',
      action: 'read',
    },
  },
  {
    path: '/product_types/add',
    name: 'Product_typesAdd',
    component: () => import('@/views/Defines/Product_types/Add.vue'),
    meta: {
      pageTitle: 'Ürün Grupları',
      breadcrumb: [
        {
          text: 'Ürün Grupları',
          to: '/product_types',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_PRODUCT_TYPES',
      action: 'read',
    },
  },
  {
    path: '/product_types/edit/:id',
    name: 'Product_typesEdit',
    component: () => import('@/views/Defines/Product_types/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Grupları',
      breadcrumb: [
        {
          text: 'Ürün Grupları',
          to: '/product_types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_PRODUCT_TYPES',
      action: 'read',
    },
  },
  {
    path: '/offer_terms',
    name: 'offer_terms',
    component: () => import('@/views/Defines/Offer_terms/Index.vue'),
    meta: {
      pageTitle: 'Teklif Özel Şartları',
      breadcrumb: [
        {
          text: 'Teklif Özel Şartları',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/offer_terms/add',
    name: 'Offer_termsAdd',
    component: () => import('@/views/Defines/Offer_terms/Add.vue'),
    meta: {
      pageTitle: 'Teklif Özel Şartları',
      breadcrumb: [
        {
          text: 'Teklif Özel Şartları',
          to: '/offer_terms',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/offer_terms/edit/:id',
    name: 'Offer_termsEdit',
    component: () => import('@/views/Defines/Offer_terms/Edit.vue'),
    meta: {
      pageTitle: 'Teklif Özel Şartları',
      breadcrumb: [
        {
          text: 'Teklif Özel Şartları',
          to: '/offer_terms',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_DEFINES_ALL',
      action: 'read',
    },
  },
]
